import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import {
  promptSessionsReducer,
  timelinesReducer,
  modelsReducer,
  documentsReducer,
  diffReducer,
  uiReducer,
} from '@repancy/core';

export const store = configureStore({
  reducer: {
    promptSessions: promptSessionsReducer,
    timelines: timelinesReducer,
    models: modelsReducer,
    documents: documentsReducer,
    diff: diffReducer,
    ui: uiReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
